// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-sched-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ad-sched-modal-content {
  background: #ffffff;
  padding: 32px;
  border-radius: 12px;
  width: 95%;
  max-width: 600px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.25s ease;
  display: flex;
  flex-direction: column;
}

.ad-sched-modal-content h3 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #1e2a38;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.ad-sched-booking-summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.label-value-pair {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  color: #333;
}

.label-value-pair strong {
  font-weight: 600;
  color: #1e2a38;
  min-width: 140px;
}

.ad-sched-slot-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0;
  list-style: none;
  margin: 12px 0 0;
}

.ad-sched-slot-list li {
  background-color: #f6f8fa;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.95rem;
  color: #2c3e50;
  border: 1px solid #d1d5da;
}

.ad-sched-break-slot {
  font-size: 0.95rem;
  color: #8e44ad;
  font-style: italic;
  margin-top: 8px;
}

.ad-sched-slot-id-preview {
  background-color: #eef4f8;
  padding: 10px 14px;
  border-left: 5px solid var(--clr-primary-3, #3498db);
  border-radius: 8px;
  font-size: 0.95rem;
  margin-top: 16px;
  word-break: break-all;
}

.ad-sched-modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 30px;
}

.ad-sched-confirm-button {
  background-color: #3498db;
  color: white;
  padding: 10px 18px;
  font-size: 0.95rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ad-sched-confirm-button:hover {
  background-color: #2980b9;
}

.ad-sched-cancel-button {
  background-color: #e0e0e0;
  color: #333;
  padding: 10px 18px;
  font-size: 0.95rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ad-sched-cancel-button:hover {
  background-color: #c4c4c4;
}

/* Animation for modal entry */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive tweak */
@media screen and (max-width: 480px) {
  .ad-sched-modal-content {
    padding: 24px 16px;
  }

  .ad-sched-modal-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .ad-sched-confirm-button,
  .ad-sched-cancel-button {
    width: 100%;
  }

  .label-value-pair {
    flex-direction: column;
    align-items: flex-start;
  }
}

.room-highlight {
  display: inline-block;
  background-color: #ffebee;  
  color: #b71c1c;             
  padding: 0.35rem 0.75rem;
  border-left: 4px solid #e53935; 
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0.4rem 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/BookingModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C","sourcesContent":[".ad-sched-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.ad-sched-modal-content {\n  background: #ffffff;\n  padding: 32px;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 600px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.ad-sched-modal-content h3 {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  color: #1e2a38;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n}\n\n.ad-sched-booking-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.label-value-pair {\n  display: flex;\n  justify-content: space-between;\n  font-size: 1rem;\n  color: #333;\n}\n\n.label-value-pair strong {\n  font-weight: 600;\n  color: #1e2a38;\n  min-width: 140px;\n}\n\n.ad-sched-slot-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 0;\n  list-style: none;\n  margin: 12px 0 0;\n}\n\n.ad-sched-slot-list li {\n  background-color: #f6f8fa;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  color: #2c3e50;\n  border: 1px solid #d1d5da;\n}\n\n.ad-sched-break-slot {\n  font-size: 0.95rem;\n  color: #8e44ad;\n  font-style: italic;\n  margin-top: 8px;\n}\n\n.ad-sched-slot-id-preview {\n  background-color: #eef4f8;\n  padding: 10px 14px;\n  border-left: 5px solid var(--clr-primary-3, #3498db);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  margin-top: 16px;\n  word-break: break-all;\n}\n\n.ad-sched-modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.ad-sched-confirm-button {\n  background-color: #3498db;\n  color: white;\n  padding: 10px 18px;\n  font-size: 0.95rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.ad-sched-confirm-button:hover {\n  background-color: #2980b9;\n}\n\n.ad-sched-cancel-button {\n  background-color: #e0e0e0;\n  color: #333;\n  padding: 10px 18px;\n  font-size: 0.95rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.ad-sched-cancel-button:hover {\n  background-color: #c4c4c4;\n}\n\n/* Animation for modal entry */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive tweak */\n@media screen and (max-width: 480px) {\n  .ad-sched-modal-content {\n    padding: 24px 16px;\n  }\n\n  .ad-sched-modal-buttons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ad-sched-confirm-button,\n  .ad-sched-cancel-button {\n    width: 100%;\n  }\n\n  .label-value-pair {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.room-highlight {\n  display: inline-block;\n  background-color: #ffebee;  \n  color: #b71c1c;             \n  padding: 0.35rem 0.75rem;\n  border-left: 4px solid #e53935; \n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  margin: 0.4rem 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
